var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialOnlyfans28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 6.668h-4.016c-3.45 0-5.3.198-6.748 1.958a7.997 7.997 0 1 0 2.103 9.212c3.183-.231 5.39-2.135 6.086-5.173 0 0-2.4.584-4.43 0 4.018-.778 6.333-3.038 7.005-5.997ZM7.607 14.665a2.391 2.391 0 0 1 3.672-2.027 2.967 2.967 0 0 1 2.997-2.529h.009c-.92 1.778-1.408 3.352-1.998 5.264a2.393 2.393 0 0 1-4.68-.708Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialOnlyfans28);
export default __webpack_public_path__ + "static/media/social-onlyfans_28.d558ddbd.svg";
export { ForwardRef as ReactComponent };